import React from "react";
import cn from "classnames";
import _ from "lodash";
import Show from "../../../widgets/Show";
import { getCompanyFormatFullDate } from "../../../../helpers/DateUtils";

const MedicalFillInFormConsultationHistory = ({ consultationHistory = [] }) => {
  return (
    <div
      className={cn("medical-fill-in-form-history", {
        "medical-fill-in-form-history--border": consultationHistory.length,
      })}
    >
      <Show if={consultationHistory.length}>
        <div className="medical-fill-in-form-history__header">
          <div className="history-item header-item">Edited by</div>
          <div className="history-item header-item">Edited on</div>
        </div>
        {consultationHistory.map((item, idx) => (
          <div key={idx} className="medical-fill-in-form-history__body">
            <div className="history-item">{_.get(item, ["creator", "name"], "---")}</div>
            <div className="history-item">
              {getCompanyFormatFullDate(_.get(item, "createdDate"))}
            </div>
          </div>
        ))}
      </Show>
    </div>
  );
};

export default MedicalFillInFormConsultationHistory;
